enum DisplayMode {
  journey,
  portal,
}

export default DisplayMode
